import { ArrowLeftRight, Clock, PackageCheck, ShieldCheck, UserCheck, WifiOff } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type Pillar = { Icon: LucideIcon; title: string; body: string };

const PILLARS: ReadonlyArray<Pillar> = [
  {
    Icon: UserCheck,
    title: 'Validation gérant',
    body: "Fixe un seuil : au-delà, le retour passe en approbation. Aucun remboursement ne sort tant que le gérant n'a pas signé.",
  },
  {
    Icon: ShieldCheck,
    title: 'Anti-sur-remboursement',
    body: "Velko empêche de rembourser plus que le montant de la vente. Le total rendu ne dépasse jamais le total payé.",
  },
  {
    Icon: ArrowLeftRight,
    title: 'Échange avec différentiel',
    body: "Le client échange contre un autre article : Velko calcule la différence à payer ou à rembourser, automatiquement.",
  },
  {
    Icon: PackageCheck,
    title: 'Restock maîtrisé',
    body: "Choisis si l'article revient en stock ou s'il est mis au rebut. Tes niveaux restent exacts dans tous les cas.",
  },
  {
    Icon: Clock,
    title: "Annulation 24 h",
    body: "Une erreur ? Un remboursement peut être annulé dans les 24 heures, avec l'autorisation du gérant.",
  },
  {
    Icon: WifiOff,
    title: 'Hors ligne natif',
    body: 'Les retours fonctionnent au comptoir sans réseau et se synchronisent au retour de la connexion. Web, desktop et mobile.',
  },
];

export default function RetoursPillarsV2() {
  return (
    <section className="bg-charcoal-800 py-20 text-white md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <SectionLabel tone="dark">Ce qu'il y a dans la boîte</SectionLabel>
        <h2 className="mt-3 max-w-3xl font-marketing-display text-[clamp(30px,4.2vw,56px)] font-bold leading-[1.02] tracking-[-0.035em] text-white">
          Un retour carré, <span className="text-lime-500">à chaque fois.</span>
        </h2>
        <p className="mt-4 max-w-xl font-marketing-body text-[17px] leading-[1.55] text-charcoal-200">
          Retours, échanges et remboursements forment un seul module — connecté à ta caisse, ton
          stock et tes clients. Rien à relier.
        </p>

        <div className="mt-12 grid gap-[2px] border-2 border-charcoal-700 bg-charcoal-700 sm:grid-cols-2 lg:grid-cols-3">
          {PILLARS.map(({ Icon, title, body }) => (
            <div
              key={title}
              className="flex min-h-[210px] flex-col gap-4 bg-charcoal-800 px-7 py-8 transition-colors duration-150 hover:bg-charcoal-900"
            >
              <span className="flex h-12 w-12 items-center justify-center border-2 border-lime-500 bg-charcoal-900 text-lime-500">
                <Icon className="h-[22px] w-[22px]" strokeWidth={2} aria-hidden="true" />
              </span>
              <h3 className="font-marketing-display text-[20px] font-bold leading-[1.15] tracking-[-0.01em] text-white">
                {title}
              </h3>
              <p className="font-marketing-body text-[14px] leading-[1.55] text-charcoal-200">
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
